/* Generated from Requests_2026-10-06_2027-02-01.xlsx (Phoenix times converted to UTC).
 * Replace this list when a new schedule spreadsheet arrives. */
import type { ScheduledSession } from "./schedule";

export const scheduledSessions: ScheduledSession[] = [
  {
    "id": "lel-20261006-1",
    "courseSlug": "developing-others-your-top-priority",
    "startDate": "2026-10-06",
    "endDate": "2026-10-20",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-06",
      "2026-10-13",
      "2026-10-20"
    ],
    "tpSessionIds": [
      13225,
      13226,
      13227
    ]
  },
  {
    "id": "lel-20261006-2",
    "courseSlug": "driving-results-through-goal-setting",
    "startDate": "2026-10-06",
    "endDate": "2026-10-20",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-06",
      "2026-10-13",
      "2026-10-20"
    ],
    "tpSessionIds": [
      13243,
      13244,
      13245
    ]
  },
  {
    "id": "lel-20261006-3",
    "courseSlug": "maximizing-strengths",
    "startDate": "2026-10-06",
    "endDate": "2026-10-20",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-06",
      "2026-10-13",
      "2026-10-20"
    ],
    "tpSessionIds": [
      13420,
      13421,
      13422
    ]
  },
  {
    "id": "lel-20261007-4",
    "courseSlug": "practical-project-management",
    "startDate": "2026-10-07",
    "endDate": "2026-11-04",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-07",
      "2026-10-14",
      "2026-10-21",
      "2026-10-28",
      "2026-11-04"
    ],
    "tpSessionIds": [
      14753,
      14754,
      14755,
      14756,
      14757
    ]
  },
  {
    "id": "lel-20261007-5",
    "courseSlug": "leading-remote-teams",
    "startDate": "2026-10-07",
    "endDate": "2026-10-28",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-07",
      "2026-10-14",
      "2026-10-21",
      "2026-10-28"
    ],
    "tpSessionIds": [
      13354,
      13355,
      13356,
      13357
    ]
  },
  {
    "id": "lel-20261007-6",
    "courseSlug": "developing-a-growth-mindset",
    "startDate": "2026-10-07",
    "endDate": "2026-10-21",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-07",
      "2026-10-14",
      "2026-10-21"
    ],
    "tpSessionIds": [
      13071,
      13072,
      13073
    ]
  },
  {
    "id": "lel-20261008-7",
    "courseSlug": "fundamentals-of-strategic-planning",
    "startDate": "2026-10-08",
    "endDate": "2026-10-22",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-08",
      "2026-10-15",
      "2026-10-22"
    ],
    "tpSessionIds": [
      13282,
      13283,
      13284
    ]
  },
  {
    "id": "lel-20261012-8",
    "courseSlug": "competitive-analysis",
    "startDate": "2026-10-12",
    "endDate": "2026-11-02",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-12",
      "2026-10-19",
      "2026-10-26",
      "2026-11-02"
    ],
    "tpSessionIds": [
      12166,
      12167,
      12168,
      12169
    ]
  },
  {
    "id": "lel-20261013-9",
    "courseSlug": "introduction-to-servant-leadership",
    "startDate": "2026-10-13",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-13"
    ],
    "tpSessionIds": [
      13317
    ]
  },
  {
    "id": "lel-20261013-10",
    "courseSlug": "delegating-for-development",
    "startDate": "2026-10-13",
    "endDate": "2026-10-27",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-13",
      "2026-10-20",
      "2026-10-27"
    ],
    "tpSessionIds": [
      13065,
      13066,
      13067
    ]
  },
  {
    "id": "lel-20261013-11",
    "courseSlug": "4p-series-communication-from-the-power-perspective",
    "startDate": "2026-10-13",
    "endDate": "2026-10-20",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-13",
      "2026-10-20"
    ],
    "tpSessionIds": [
      12110,
      12111
    ]
  },
  {
    "id": "lel-20261013-12",
    "courseSlug": "finding-your-purpose",
    "startDate": "2026-10-13",
    "endDate": "2026-10-27",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-13",
      "2026-10-20",
      "2026-10-27"
    ],
    "tpSessionIds": [
      13276,
      13277,
      13278
    ]
  },
  {
    "id": "lel-20261014-13",
    "courseSlug": "developing-positive-relationships-at-work",
    "startDate": "2026-10-14",
    "endDate": "2026-10-28",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-14",
      "2026-10-21",
      "2026-10-28"
    ],
    "tpSessionIds": [
      13231,
      13232,
      13233
    ]
  },
  {
    "id": "lel-20261014-14",
    "courseSlug": "leadership-essentials-with-a-foundation-of-emotional-intelligence",
    "startDate": "2026-10-14",
    "endDate": "2026-11-04",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-14",
      "2026-10-21",
      "2026-10-28",
      "2026-11-04"
    ],
    "tpSessionIds": [
      13324,
      13325,
      13326,
      13327
    ]
  },
  {
    "id": "lel-20261015-15",
    "courseSlug": "managing-up",
    "startDate": "2026-10-15",
    "endDate": "2026-10-29",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-15",
      "2026-10-22",
      "2026-10-29"
    ],
    "tpSessionIds": [
      13408,
      13409,
      13410
    ]
  },
  {
    "id": "lel-20261016-16",
    "courseSlug": "equity-diversity-and-inclusion-in-the-workplace",
    "startDate": "2026-10-16",
    "endDate": "2026-11-06",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-16",
      "2026-10-23",
      "2026-10-30",
      "2026-11-06"
    ],
    "tpSessionIds": [
      13264,
      13265,
      13266,
      13267
    ]
  },
  {
    "id": "lel-20261020-17",
    "courseSlug": "turn-your-ideas-into-results",
    "startDate": "2026-10-20",
    "endDate": "2026-11-03",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-20",
      "2026-10-27",
      "2026-11-03"
    ],
    "tpSessionIds": [
      15082,
      15083,
      15084
    ]
  },
  {
    "id": "lel-20261020-18",
    "courseSlug": "uncovering-bias",
    "startDate": "2026-10-20",
    "endDate": "2026-11-03",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-20",
      "2026-10-27",
      "2026-11-03"
    ],
    "tpSessionIds": [
      15088,
      15089,
      15090
    ]
  },
  {
    "id": "lel-20261022-19",
    "courseSlug": "improve-communication-through-the-4p-personality-styles",
    "startDate": "2026-10-22",
    "endDate": "2026-11-12",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-22",
      "2026-10-29",
      "2026-11-05",
      "2026-11-12"
    ],
    "tpSessionIds": [
      13296,
      13297,
      13298,
      13299
    ]
  },
  {
    "id": "lel-20261022-20",
    "courseSlug": "managing-emotions",
    "startDate": "2026-10-22",
    "endDate": "2026-11-05",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-22",
      "2026-10-29",
      "2026-11-05"
    ],
    "tpSessionIds": [
      13388,
      13389,
      13390
    ]
  },
  {
    "id": "lel-20261022-21",
    "courseSlug": "masterfully-managing-meetings",
    "startDate": "2026-10-22",
    "endDate": "2026-11-05",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-22",
      "2026-10-29",
      "2026-11-05"
    ],
    "tpSessionIds": [
      13414,
      13415,
      13416
    ]
  },
  {
    "id": "lel-20261022-22",
    "courseSlug": "on-the-spot-development-conversations",
    "startDate": "2026-10-22",
    "endDate": "2026-11-05",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-22",
      "2026-10-29",
      "2026-11-05"
    ],
    "tpSessionIds": [
      13627,
      13628,
      13629
    ]
  },
  {
    "id": "lel-20261022-23",
    "courseSlug": "psychological-safety",
    "startDate": "2026-10-22",
    "endDate": "2026-11-05",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-22",
      "2026-10-29",
      "2026-11-05"
    ],
    "tpSessionIds": [
      14771,
      14772,
      14773
    ]
  },
  {
    "id": "lel-20261022-24",
    "courseSlug": "soar-analysis",
    "startDate": "2026-10-22",
    "endDate": "2026-11-05",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-22",
      "2026-10-29",
      "2026-11-05"
    ],
    "tpSessionIds": [
      14794,
      14795,
      14796
    ]
  },
  {
    "id": "lel-20261023-25",
    "courseSlug": "navigating-organizational-politics",
    "startDate": "2026-10-23",
    "endDate": "2026-11-13",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-23",
      "2026-10-30",
      "2026-11-06",
      "2026-11-13"
    ],
    "tpSessionIds": [
      13605,
      13606,
      13607,
      13608
    ]
  },
  {
    "id": "lel-20261023-26",
    "courseSlug": "business-etiquette",
    "startDate": "2026-10-23",
    "endDate": "2026-11-06",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-23",
      "2026-10-30",
      "2026-11-06"
    ],
    "tpSessionIds": [
      12151,
      12152,
      12153
    ]
  },
  {
    "id": "lel-20261026-27",
    "courseSlug": "4p-series-communication-from-the-passion-perspective",
    "startDate": "2026-10-26",
    "endDate": "2026-11-02",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-26",
      "2026-11-02"
    ],
    "tpSessionIds": [
      11967,
      11968
    ]
  },
  {
    "id": "lel-20261027-28",
    "courseSlug": "the-art-of-small-talk-and-networking",
    "startDate": "2026-10-27",
    "endDate": "2026-11-10",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-27",
      "2026-11-03",
      "2026-11-10"
    ],
    "tpSessionIds": [
      14820,
      14821,
      14822
    ]
  },
  {
    "id": "lel-20261028-29",
    "courseSlug": "leading-with-an-inclusive-mindset",
    "startDate": "2026-10-28",
    "endDate": "2026-11-18",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-28",
      "2026-11-04",
      "2026-11-11",
      "2026-11-18"
    ],
    "tpSessionIds": [
      13362,
      13363,
      13364,
      13365
    ]
  },
  {
    "id": "lel-20261028-30",
    "courseSlug": "negotiation-for-mutual-success",
    "startDate": "2026-10-28",
    "endDate": "2026-11-11",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-28",
      "2026-11-04",
      "2026-11-11"
    ],
    "tpSessionIds": [
      13613,
      13614,
      13615
    ]
  },
  {
    "id": "lel-20261028-31",
    "courseSlug": "true-empowerment",
    "startDate": "2026-10-28",
    "endDate": "2026-11-11",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-28",
      "2026-11-04",
      "2026-11-11"
    ],
    "tpSessionIds": [
      15076,
      15077,
      15078
    ]
  },
  {
    "id": "lel-20261029-32",
    "courseSlug": "managing-organizational-conflict",
    "startDate": "2026-10-29",
    "endDate": "2026-11-19",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-29",
      "2026-11-05",
      "2026-11-12",
      "2026-11-19"
    ],
    "tpSessionIds": [
      13394,
      13395,
      13396,
      13397
    ]
  },
  {
    "id": "lel-20261029-33",
    "courseSlug": "new-leader-boot-camp",
    "startDate": "2026-10-29",
    "endDate": "2026-11-19",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-29",
      "2026-11-05",
      "2026-11-12",
      "2026-11-19"
    ],
    "tpSessionIds": [
      13619,
      13620,
      13621,
      13622
    ]
  },
  {
    "id": "lel-20261029-34",
    "courseSlug": "servant-leadership-ii-manager-as-servant-leader",
    "startDate": "2026-10-29",
    "endDate": "2026-11-19",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-29",
      "2026-11-05",
      "2026-11-12",
      "2026-11-19"
    ],
    "tpSessionIds": [
      14777,
      14778,
      14779,
      14780
    ]
  },
  {
    "id": "lel-20261029-35",
    "courseSlug": "leading-leaders",
    "startDate": "2026-10-29",
    "endDate": "2026-11-12",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-29",
      "2026-11-05",
      "2026-11-12"
    ],
    "tpSessionIds": [
      13348,
      13349,
      13350
    ]
  },
  {
    "id": "lel-20261030-36",
    "courseSlug": "making-better-decisions-through-critical-thinking",
    "startDate": "2026-10-30",
    "endDate": "2026-11-27",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-30",
      "2026-11-06",
      "2026-11-13",
      "2026-11-20",
      "2026-11-27"
    ],
    "tpSessionIds": [
      13370,
      13371,
      13372,
      13373,
      13374
    ]
  },
  {
    "id": "lel-20261030-37",
    "courseSlug": "building-employee-engagement",
    "startDate": "2026-10-30",
    "endDate": "2026-11-13",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-30",
      "2026-11-06",
      "2026-11-13"
    ],
    "tpSessionIds": [
      12145,
      12146,
      12147
    ]
  },
  {
    "id": "lel-20261030-38",
    "courseSlug": "emotional-and-cognitive-empathy",
    "startDate": "2026-10-30",
    "endDate": "2026-11-13",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-30",
      "2026-11-06",
      "2026-11-13"
    ],
    "tpSessionIds": [
      13255,
      13256,
      13257
    ]
  },
  {
    "id": "lel-20261030-39",
    "courseSlug": "emotional-triggers",
    "startDate": "2026-10-30",
    "endDate": "2026-11-13",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-10-30",
      "2026-11-06",
      "2026-11-13"
    ],
    "tpSessionIds": [
      13258,
      13259,
      13260
    ]
  },
  {
    "id": "lel-20261102-40",
    "courseSlug": "how-to-make-yourself-indispensable",
    "startDate": "2026-11-02",
    "endDate": "2026-11-23",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-02",
      "2026-11-09",
      "2026-11-16",
      "2026-11-23"
    ],
    "tpSessionIds": [
      13288,
      13289,
      13290,
      13291
    ]
  },
  {
    "id": "lel-20261102-41",
    "courseSlug": "leading-change",
    "startDate": "2026-11-02",
    "endDate": "2026-11-23",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-02",
      "2026-11-09",
      "2026-11-16",
      "2026-11-23"
    ],
    "tpSessionIds": [
      13340,
      13341,
      13342,
      13343
    ]
  },
  {
    "id": "lel-20261102-42",
    "courseSlug": "skillful-collaboration",
    "startDate": "2026-11-02",
    "endDate": "2026-11-16",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-02",
      "2026-11-09",
      "2026-11-16"
    ],
    "tpSessionIds": [
      14788,
      14789,
      14790
    ]
  },
  {
    "id": "lel-20261102-43",
    "courseSlug": "stakeholder-management",
    "startDate": "2026-11-02",
    "endDate": "2026-11-16",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-02",
      "2026-11-09",
      "2026-11-16"
    ],
    "tpSessionIds": [
      14800,
      14801,
      14802
    ]
  },
  {
    "id": "lel-20261102-44",
    "courseSlug": "the-invincible-influencer",
    "startDate": "2026-11-02",
    "endDate": "2026-11-23",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-02",
      "2026-11-09",
      "2026-11-16",
      "2026-11-23"
    ],
    "tpSessionIds": [
      15068,
      15069,
      15070,
      15071
    ]
  },
  {
    "id": "lel-20261103-45",
    "courseSlug": "competency-and-behavioral-based-interviewing",
    "startDate": "2026-11-03",
    "endDate": "2026-12-01",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-03",
      "2026-11-10",
      "2026-11-17",
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      12161,
      12162,
      12163,
      12164,
      12165
    ]
  },
  {
    "id": "lel-20261103-46",
    "courseSlug": "adapting-your-leadership-style",
    "startDate": "2026-11-03",
    "endDate": "2026-11-17",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-03",
      "2026-11-10",
      "2026-11-17"
    ],
    "tpSessionIds": [
      12116,
      12117,
      12118
    ]
  },
  {
    "id": "lel-20261103-47",
    "courseSlug": "creating-a-culture-of-trust",
    "startDate": "2026-11-03",
    "endDate": "2026-11-17",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-03",
      "2026-11-10",
      "2026-11-17"
    ],
    "tpSessionIds": [
      12185,
      12186,
      12187
    ]
  },
  {
    "id": "lel-20261103-48",
    "courseSlug": "creative-problem-solving",
    "startDate": "2026-11-03",
    "endDate": "2026-11-17",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-03",
      "2026-11-10",
      "2026-11-17"
    ],
    "tpSessionIds": [
      13055,
      13056,
      13057
    ]
  },
  {
    "id": "lel-20261103-49",
    "courseSlug": "influence-without-authority",
    "startDate": "2026-11-03",
    "endDate": "2026-11-17",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-03",
      "2026-11-10",
      "2026-11-17"
    ],
    "tpSessionIds": [
      13308,
      13309,
      13310
    ]
  },
  {
    "id": "lel-20261104-50",
    "courseSlug": "weathering-the-storm-learning-to-be-resilient",
    "startDate": "2026-11-04",
    "endDate": "2026-11-25",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-04",
      "2026-11-11",
      "2026-11-18",
      "2026-11-25"
    ],
    "tpSessionIds": [
      15095,
      15096,
      15097,
      15098
    ]
  },
  {
    "id": "lel-20261104-51",
    "courseSlug": "assertiveness-skills",
    "startDate": "2026-11-04",
    "endDate": "2026-11-18",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-04",
      "2026-11-11",
      "2026-11-18"
    ],
    "tpSessionIds": [
      12128,
      12129,
      12130
    ]
  },
  {
    "id": "lel-20261104-52",
    "courseSlug": "building-authentic-relationships",
    "startDate": "2026-11-04",
    "endDate": "2026-11-18",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-04",
      "2026-11-11",
      "2026-11-18"
    ],
    "tpSessionIds": [
      12139,
      12140,
      12141
    ]
  },
  {
    "id": "lel-20261104-53",
    "courseSlug": "the-experienced-leader-boot-camp",
    "startDate": "2026-11-04",
    "endDate": "2026-11-18",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-04",
      "2026-11-11",
      "2026-11-18"
    ],
    "tpSessionIds": [
      15062,
      15063,
      15064
    ]
  },
  {
    "id": "lel-20261105-54",
    "courseSlug": "conquering-conflict",
    "startDate": "2026-11-05",
    "endDate": "2026-11-19",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-05",
      "2026-11-12",
      "2026-11-19"
    ],
    "tpSessionIds": [
      12179,
      12180,
      12181
    ]
  },
  {
    "id": "lel-20261105-55",
    "courseSlug": "the-art-of-influence",
    "startDate": "2026-11-05",
    "endDate": "2026-11-19",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-05",
      "2026-11-12",
      "2026-11-19"
    ],
    "tpSessionIds": [
      14814,
      14815,
      14816
    ]
  },
  {
    "id": "lel-20261109-56",
    "courseSlug": "4p-series-communication-from-the-people-perspective",
    "startDate": "2026-11-09",
    "endDate": "2026-11-16",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-09",
      "2026-11-16"
    ],
    "tpSessionIds": [
      11971,
      11972
    ]
  },
  {
    "id": "lel-20261109-57",
    "courseSlug": "developing-dynamic-teams",
    "startDate": "2026-11-09",
    "endDate": "2026-11-30",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-09",
      "2026-11-16",
      "2026-11-23",
      "2026-11-30"
    ],
    "tpSessionIds": [
      13221,
      13222,
      13223,
      13224
    ]
  },
  {
    "id": "lel-20261109-58",
    "courseSlug": "professional-pathways-building-a-vision-for-your-career",
    "startDate": "2026-11-09",
    "endDate": "2026-11-30",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-09",
      "2026-11-16",
      "2026-11-23",
      "2026-11-30"
    ],
    "tpSessionIds": [
      14767,
      14768,
      14769,
      14770
    ]
  },
  {
    "id": "lel-20261109-59",
    "courseSlug": "analytical-thinking-skills",
    "startDate": "2026-11-09",
    "endDate": "2026-11-23",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-09",
      "2026-11-16",
      "2026-11-23"
    ],
    "tpSessionIds": [
      12122,
      12123,
      12124
    ]
  },
  {
    "id": "lel-20261109-60",
    "courseSlug": "the-mentoring-mindset",
    "startDate": "2026-11-09",
    "endDate": "2026-11-23",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-09",
      "2026-11-16",
      "2026-11-23"
    ],
    "tpSessionIds": [
      15240,
      15241,
      15242
    ]
  },
  {
    "id": "lel-20261110-61",
    "courseSlug": "strengthening-teams-through-communication",
    "startDate": "2026-11-10",
    "endDate": "2026-12-08",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-10",
      "2026-11-17",
      "2026-11-24",
      "2026-12-01",
      "2026-12-08"
    ],
    "tpSessionIds": [
      14806,
      14807,
      14808,
      14810,
      14809
    ]
  },
  {
    "id": "lel-20261110-62",
    "courseSlug": "manage-your-time-master-your-life",
    "startDate": "2026-11-10",
    "endDate": "2026-12-01",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-10",
      "2026-11-17",
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      13380,
      13381,
      13382,
      13383
    ]
  },
  {
    "id": "lel-20261110-63",
    "courseSlug": "managing-stress",
    "startDate": "2026-11-10",
    "endDate": "2026-11-24",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-10",
      "2026-11-17",
      "2026-11-24"
    ],
    "tpSessionIds": [
      13402,
      13403,
      13404
    ]
  },
  {
    "id": "lel-20261110-64",
    "courseSlug": "motivation-models-carrot-or-stick",
    "startDate": "2026-11-10",
    "endDate": "2026-11-24",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-10",
      "2026-11-17",
      "2026-11-24"
    ],
    "tpSessionIds": [
      13429,
      13430,
      13431
    ]
  },
  {
    "id": "lel-20261111-65",
    "courseSlug": "performance-management",
    "startDate": "2026-11-11",
    "endDate": "2026-11-25",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-11",
      "2026-11-18",
      "2026-11-25"
    ],
    "tpSessionIds": [
      14747,
      14748,
      14749
    ]
  },
  {
    "id": "lel-20261111-66",
    "courseSlug": "financial-intelligence",
    "startDate": "2026-11-11",
    "endDate": "2026-12-09",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-11",
      "2026-11-18",
      "2026-11-25",
      "2026-12-02",
      "2026-12-09"
    ],
    "tpSessionIds": [
      13271,
      13272,
      13273,
      13274,
      13275
    ]
  },
  {
    "id": "lel-20261112-67",
    "courseSlug": "leadership-essentials-with-a-foundation-of-emotional-intelligence",
    "startDate": "2026-11-12",
    "endDate": "2026-12-10",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-12",
      "2026-11-19",
      "2026-12-03",
      "2026-12-10"
    ],
    "tpSessionIds": [
      13328,
      13329,
      13330,
      13331
    ]
  },
  {
    "id": "lel-20261112-68",
    "courseSlug": "powerful-presentations",
    "startDate": "2026-11-12",
    "endDate": "2026-12-03",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-12",
      "2026-11-19",
      "2026-12-03"
    ],
    "tpSessionIds": [
      15103,
      15104,
      15105
    ]
  },
  {
    "id": "lel-20261117-69",
    "courseSlug": "developing-a-growth-mindset",
    "startDate": "2026-11-17",
    "endDate": "2026-12-01",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-17",
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      13074,
      13075,
      13076
    ]
  },
  {
    "id": "lel-20261117-70",
    "courseSlug": "ethics-in-the-workplace",
    "startDate": "2026-11-17",
    "endDate": "2026-12-01",
    "time": "02:00 - 02:30 UTC",
    "startTime": "02:00",
    "endTime": "02:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-17",
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      13268,
      13269,
      13270
    ]
  },
  {
    "id": "lel-20261117-71",
    "courseSlug": "fundamentals-of-strategic-planning",
    "startDate": "2026-11-17",
    "endDate": "2026-12-01",
    "time": "03:00 - 03:30 UTC",
    "startTime": "03:00",
    "endTime": "03:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-17",
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      13285,
      13286,
      13287
    ]
  },
  {
    "id": "lel-20261117-72",
    "courseSlug": "mindfulness-as-a-differentiator",
    "startDate": "2026-11-17",
    "endDate": "2026-12-01",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-17",
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      13426,
      13427,
      13428
    ]
  },
  {
    "id": "lel-20261118-73",
    "courseSlug": "customer-service-excellence",
    "startDate": "2026-11-18",
    "endDate": "2026-12-09",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-18",
      "2026-11-25",
      "2026-12-02",
      "2026-12-09"
    ],
    "tpSessionIds": [
      13061,
      13062,
      13063,
      13064
    ]
  },
  {
    "id": "lel-20261118-74",
    "courseSlug": "development-to-delegation-cycle",
    "startDate": "2026-11-18",
    "endDate": "2026-12-02",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-18",
      "2026-11-25",
      "2026-12-02"
    ],
    "tpSessionIds": [
      13240,
      13241,
      13242
    ]
  },
  {
    "id": "lel-20261118-75",
    "courseSlug": "developing-others-your-top-priority",
    "startDate": "2026-11-18",
    "endDate": "2026-12-02",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-18",
      "2026-11-25",
      "2026-12-02"
    ],
    "tpSessionIds": [
      13228,
      13229,
      13230
    ]
  },
  {
    "id": "lel-20261118-76",
    "courseSlug": "driving-results-through-goal-setting",
    "startDate": "2026-11-18",
    "endDate": "2026-12-02",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-18",
      "2026-11-25",
      "2026-12-02"
    ],
    "tpSessionIds": [
      13246,
      13247,
      13248
    ]
  },
  {
    "id": "lel-20261119-77",
    "courseSlug": "improve-communication-through-the-4p-personality-styles",
    "startDate": "2026-11-19",
    "endDate": "2026-12-17",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-19",
      "2026-12-03",
      "2026-12-10",
      "2026-12-17"
    ],
    "tpSessionIds": [
      13300,
      13301,
      13302,
      13303
    ]
  },
  {
    "id": "lel-20261120-78",
    "courseSlug": "balancing-priorities",
    "startDate": "2026-11-20",
    "endDate": "2026-12-18",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-20",
      "2026-11-27",
      "2026-12-04",
      "2026-12-11",
      "2026-12-18"
    ],
    "tpSessionIds": [
      12134,
      12135,
      12136,
      12137,
      12138
    ]
  },
  {
    "id": "lel-20261120-79",
    "courseSlug": "collaborative-coaching-conversations",
    "startDate": "2026-11-20",
    "endDate": "2026-12-11",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-20",
      "2026-11-27",
      "2026-12-04",
      "2026-12-11"
    ],
    "tpSessionIds": [
      12157,
      12158,
      12159,
      12160
    ]
  },
  {
    "id": "lel-20261123-80",
    "courseSlug": "connecting-across-cultures",
    "startDate": "2026-11-23",
    "endDate": "2026-12-21",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-23",
      "2026-11-30",
      "2026-12-07",
      "2026-12-14",
      "2026-12-21"
    ],
    "tpSessionIds": [
      12174,
      12175,
      12176,
      12177,
      12178
    ]
  },
  {
    "id": "lel-20261123-81",
    "courseSlug": "introduction-to-servant-leadership",
    "startDate": "2026-11-23",
    "endDate": "2026-12-14",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-23",
      "2026-11-30",
      "2026-12-07",
      "2026-12-14"
    ],
    "tpSessionIds": [
      13320,
      13321,
      13322,
      13323
    ]
  },
  {
    "id": "lel-20261123-82",
    "courseSlug": "leading-remote-teams",
    "startDate": "2026-11-23",
    "endDate": "2026-12-14",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-23",
      "2026-11-30",
      "2026-12-07",
      "2026-12-14"
    ],
    "tpSessionIds": [
      13358,
      13359,
      13360,
      13361
    ]
  },
  {
    "id": "lel-20261124-83",
    "courseSlug": "developing-positive-relationships-at-work",
    "startDate": "2026-11-24",
    "endDate": "2026-12-08",
    "time": "01:00 - 01:30 UTC",
    "startTime": "01:00",
    "endTime": "01:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-24",
      "2026-12-01",
      "2026-12-08"
    ],
    "tpSessionIds": [
      13234,
      13235,
      13236
    ]
  },
  {
    "id": "lel-20261124-84",
    "courseSlug": "4p-series-communication-from-the-precise-perspective",
    "startDate": "2026-11-24",
    "endDate": "2026-12-01",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-24",
      "2026-12-01"
    ],
    "tpSessionIds": [
      12114,
      12115
    ]
  },
  {
    "id": "lel-20261125-85",
    "courseSlug": "delegating-for-development",
    "startDate": "2026-11-25",
    "endDate": "2026-12-09",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-25",
      "2026-12-02",
      "2026-12-09"
    ],
    "tpSessionIds": [
      13068,
      13069,
      13070
    ]
  },
  {
    "id": "lel-20261125-86",
    "courseSlug": "finding-your-purpose",
    "startDate": "2026-11-25",
    "endDate": "2026-12-09",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-25",
      "2026-12-02",
      "2026-12-09"
    ],
    "tpSessionIds": [
      13279,
      13280,
      13281
    ]
  },
  {
    "id": "lel-20261125-87",
    "courseSlug": "managing-up",
    "startDate": "2026-11-25",
    "endDate": "2026-12-09",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-25",
      "2026-12-02",
      "2026-12-09"
    ],
    "tpSessionIds": [
      13411,
      13412,
      13413
    ]
  },
  {
    "id": "lel-20261126-88",
    "courseSlug": "maximizing-strengths",
    "startDate": "2026-11-26",
    "endDate": "2026-12-10",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-11-26",
      "2026-12-03",
      "2026-12-10"
    ],
    "tpSessionIds": [
      13423,
      13424,
      13425
    ]
  },
  {
    "id": "lel-20261203-89",
    "courseSlug": "masterfully-managing-meetings",
    "startDate": "2026-12-03",
    "endDate": "2026-12-17",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-03",
      "2026-12-10",
      "2026-12-17"
    ],
    "tpSessionIds": [
      13417,
      13418,
      13419
    ]
  },
  {
    "id": "lel-20261203-90",
    "courseSlug": "on-the-spot-development-conversations",
    "startDate": "2026-12-03",
    "endDate": "2026-12-17",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-03",
      "2026-12-10",
      "2026-12-17"
    ],
    "tpSessionIds": [
      14744,
      14745,
      14746
    ]
  },
  {
    "id": "lel-20261203-91",
    "courseSlug": "psychological-safety",
    "startDate": "2026-12-03",
    "endDate": "2026-12-17",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-03",
      "2026-12-10",
      "2026-12-17"
    ],
    "tpSessionIds": [
      14774,
      14775,
      14776
    ]
  },
  {
    "id": "lel-20261203-92",
    "courseSlug": "turn-your-ideas-into-results",
    "startDate": "2026-12-03",
    "endDate": "2026-12-17",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-03",
      "2026-12-10",
      "2026-12-17"
    ],
    "tpSessionIds": [
      15085,
      15086,
      15087
    ]
  },
  {
    "id": "lel-20261204-93",
    "courseSlug": "managing-emotions",
    "startDate": "2026-12-04",
    "endDate": "2026-12-18",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-04",
      "2026-12-11",
      "2026-12-18"
    ],
    "tpSessionIds": [
      13391,
      13392,
      13393
    ]
  },
  {
    "id": "lel-20261207-94",
    "courseSlug": "practical-project-management",
    "startDate": "2026-12-07",
    "endDate": "2027-01-04",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-07",
      "2026-12-14",
      "2026-12-21",
      "2026-12-28",
      "2027-01-04"
    ],
    "tpSessionIds": [
      14758,
      14759,
      14761,
      14760,
      24186
    ]
  },
  {
    "id": "lel-20261207-95",
    "courseSlug": "influence-without-authority",
    "startDate": "2026-12-07",
    "endDate": "2026-12-21",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-07",
      "2026-12-14",
      "2026-12-21"
    ],
    "tpSessionIds": [
      13311,
      13312,
      13313
    ]
  },
  {
    "id": "lel-20261208-96",
    "courseSlug": "the-art-of-influence",
    "startDate": "2026-12-08",
    "endDate": "2026-12-22",
    "time": "02:00 - 02:30 UTC",
    "startTime": "02:00",
    "endTime": "02:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-08",
      "2026-12-15",
      "2026-12-22"
    ],
    "tpSessionIds": [
      14817,
      14818,
      14819
    ]
  },
  {
    "id": "lel-20261208-97",
    "courseSlug": "building-employee-engagement",
    "startDate": "2026-12-08",
    "endDate": "2026-12-22",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-08",
      "2026-12-15",
      "2026-12-22"
    ],
    "tpSessionIds": [
      12148,
      12149,
      12150
    ]
  },
  {
    "id": "lel-20261208-98",
    "courseSlug": "competitive-analysis",
    "startDate": "2026-12-08",
    "endDate": "2026-12-29",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-08",
      "2026-12-15",
      "2026-12-22",
      "2026-12-29"
    ],
    "tpSessionIds": [
      12170,
      12171,
      12172,
      12173
    ]
  },
  {
    "id": "lel-20261208-99",
    "courseSlug": "navigating-organizational-politics",
    "startDate": "2026-12-08",
    "endDate": "2026-12-29",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-08",
      "2026-12-15",
      "2026-12-22",
      "2026-12-29"
    ],
    "tpSessionIds": [
      13609,
      13610,
      13611,
      13612
    ]
  },
  {
    "id": "lel-20261209-100",
    "courseSlug": "leading-leaders",
    "startDate": "2026-12-09",
    "endDate": "2026-12-23",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-09",
      "2026-12-16",
      "2026-12-23"
    ],
    "tpSessionIds": [
      13351,
      13352,
      13353
    ]
  },
  {
    "id": "lel-20261209-101",
    "courseSlug": "business-etiquette",
    "startDate": "2026-12-09",
    "endDate": "2026-12-23",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-09",
      "2026-12-16",
      "2026-12-23"
    ],
    "tpSessionIds": [
      12154,
      12155,
      12156
    ]
  },
  {
    "id": "lel-20261209-102",
    "courseSlug": "succession-planning-principles",
    "startDate": "2026-12-09",
    "endDate": "2026-12-23",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-09",
      "2026-12-16",
      "2026-12-23"
    ],
    "tpSessionIds": [
      14811,
      14812,
      14813
    ]
  },
  {
    "id": "lel-20261209-103",
    "courseSlug": "negotiation-for-mutual-success",
    "startDate": "2026-12-09",
    "endDate": "2026-12-23",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-09",
      "2026-12-16",
      "2026-12-23"
    ],
    "tpSessionIds": [
      13616,
      13617,
      13618
    ]
  },
  {
    "id": "lel-20261210-104",
    "courseSlug": "4p-series-communication-from-the-power-perspective",
    "startDate": "2026-12-10",
    "endDate": "2026-12-17",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-10",
      "2026-12-17"
    ],
    "tpSessionIds": [
      12112,
      12113
    ]
  },
  {
    "id": "lel-20261214-105",
    "courseSlug": "assertiveness-skills",
    "startDate": "2026-12-14",
    "endDate": "2026-12-28",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-14",
      "2026-12-21",
      "2026-12-28"
    ],
    "tpSessionIds": [
      12131,
      12132,
      12133
    ]
  },
  {
    "id": "lel-20261214-106",
    "courseSlug": "weathering-the-storm-learning-to-be-resilient",
    "startDate": "2026-12-14",
    "endDate": "2027-01-04",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-14",
      "2026-12-21",
      "2026-12-28",
      "2027-01-04"
    ],
    "tpSessionIds": [
      15099,
      15100,
      15101,
      15102
    ]
  },
  {
    "id": "lel-20261214-107",
    "courseSlug": "creating-a-culture-of-trust",
    "startDate": "2026-12-14",
    "endDate": "2026-12-28",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-14",
      "2026-12-21",
      "2026-12-28"
    ],
    "tpSessionIds": [
      12188,
      12189,
      12190
    ]
  },
  {
    "id": "lel-20261215-108",
    "courseSlug": "stakeholder-management",
    "startDate": "2026-12-15",
    "endDate": "2026-12-29",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-15",
      "2026-12-22",
      "2026-12-29"
    ],
    "tpSessionIds": [
      14803,
      14804,
      14805
    ]
  },
  {
    "id": "lel-20261215-109",
    "courseSlug": "the-invincible-influencer",
    "startDate": "2026-12-15",
    "endDate": "2027-01-05",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-15",
      "2026-12-22",
      "2026-12-29",
      "2027-01-05"
    ],
    "tpSessionIds": [
      15072,
      15073,
      15074,
      15075
    ]
  },
  {
    "id": "lel-20261215-110",
    "courseSlug": "leadership-essentials-with-a-foundation-of-emotional-intelligence",
    "startDate": "2026-12-15",
    "endDate": "2027-01-05",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-15",
      "2026-12-22",
      "2026-12-29",
      "2027-01-05"
    ],
    "tpSessionIds": [
      13332,
      13333,
      13334,
      24161
    ]
  },
  {
    "id": "lel-20261216-111",
    "courseSlug": "creative-problem-solving",
    "startDate": "2026-12-16",
    "endDate": "2026-12-30",
    "time": "14:00 - 14:30 UTC",
    "startTime": "14:00",
    "endTime": "14:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-16",
      "2026-12-23",
      "2026-12-30"
    ],
    "tpSessionIds": [
      13058,
      13059,
      13060
    ]
  },
  {
    "id": "lel-20261216-112",
    "courseSlug": "emotional-triggers",
    "startDate": "2026-12-16",
    "endDate": "2026-12-30",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-16",
      "2026-12-23",
      "2026-12-30"
    ],
    "tpSessionIds": [
      13261,
      13262,
      13263
    ]
  },
  {
    "id": "lel-20261216-113",
    "courseSlug": "soar-analysis",
    "startDate": "2026-12-16",
    "endDate": "2026-12-30",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-16",
      "2026-12-23",
      "2026-12-30"
    ],
    "tpSessionIds": [
      14797,
      14798,
      14799
    ]
  },
  {
    "id": "lel-20261216-114",
    "courseSlug": "the-art-of-small-talk-and-networking",
    "startDate": "2026-12-16",
    "endDate": "2026-12-30",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-16",
      "2026-12-23",
      "2026-12-30"
    ],
    "tpSessionIds": [
      14823,
      14824,
      14825
    ]
  },
  {
    "id": "lel-20261217-115",
    "courseSlug": "skillful-collaboration",
    "startDate": "2026-12-17",
    "endDate": "2026-12-31",
    "time": "00:00 - 00:30 UTC",
    "startTime": "00:00",
    "endTime": "00:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-17",
      "2026-12-24",
      "2026-12-31"
    ],
    "tpSessionIds": [
      14791,
      14792,
      14793
    ]
  },
  {
    "id": "lel-20261217-116",
    "courseSlug": "true-empowerment",
    "startDate": "2026-12-17",
    "endDate": "2026-12-31",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-17",
      "2026-12-24",
      "2026-12-31"
    ],
    "tpSessionIds": [
      15079,
      15080,
      15081
    ]
  },
  {
    "id": "lel-20261217-117",
    "courseSlug": "conquering-conflict",
    "startDate": "2026-12-17",
    "endDate": "2026-12-31",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-17",
      "2026-12-24",
      "2026-12-31"
    ],
    "tpSessionIds": [
      12182,
      12183,
      12184
    ]
  },
  {
    "id": "lel-20261221-118",
    "courseSlug": "building-authentic-relationships",
    "startDate": "2026-12-21",
    "endDate": "2027-01-04",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-21",
      "2026-12-28",
      "2027-01-04"
    ],
    "tpSessionIds": [
      12142,
      12143,
      24157
    ]
  },
  {
    "id": "lel-20261221-119",
    "courseSlug": "the-experienced-leader-boot-camp",
    "startDate": "2026-12-21",
    "endDate": "2027-01-04",
    "time": "17:00 - 17:30 UTC",
    "startTime": "17:00",
    "endTime": "17:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-21",
      "2026-12-28",
      "2027-01-04"
    ],
    "tpSessionIds": [
      15065,
      15066,
      24176
    ]
  },
  {
    "id": "lel-20261221-120",
    "courseSlug": "managing-organizational-conflict",
    "startDate": "2026-12-21",
    "endDate": "2027-01-11",
    "time": "19:00 - 19:30 UTC",
    "startTime": "19:00",
    "endTime": "19:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-21",
      "2026-12-28",
      "2027-01-04",
      "2027-01-11"
    ],
    "tpSessionIds": [
      13398,
      13399,
      24170,
      24171
    ]
  },
  {
    "id": "lel-20261222-121",
    "courseSlug": "leading-change",
    "startDate": "2026-12-22",
    "endDate": "2027-01-12",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-22",
      "2026-12-29",
      "2027-01-05",
      "2027-01-12"
    ],
    "tpSessionIds": [
      13344,
      13345,
      24162,
      24163
    ]
  },
  {
    "id": "lel-20261222-122",
    "courseSlug": "making-better-decisions-through-critical-thinking",
    "startDate": "2026-12-22",
    "endDate": "2027-01-19",
    "time": "18:00 - 18:30 UTC",
    "startTime": "18:00",
    "endTime": "18:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-22",
      "2026-12-29",
      "2027-01-05",
      "2027-01-12",
      "2027-01-19"
    ],
    "tpSessionIds": [
      13375,
      13376,
      24167,
      24168,
      24169
    ]
  },
  {
    "id": "lel-20261222-123",
    "courseSlug": "how-to-make-yourself-indispensable",
    "startDate": "2026-12-22",
    "endDate": "2027-01-12",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-22",
      "2026-12-29",
      "2027-01-05",
      "2027-01-12"
    ],
    "tpSessionIds": [
      13292,
      13293,
      13294,
      13295
    ]
  },
  {
    "id": "lel-20261222-124",
    "courseSlug": "emotional-and-cognitive-empathy",
    "startDate": "2026-12-22",
    "endDate": "2027-01-05",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-22",
      "2026-12-29",
      "2027-01-05"
    ],
    "tpSessionIds": [
      13252,
      13253,
      24158
    ]
  },
  {
    "id": "lel-20261222-125",
    "courseSlug": "improve-communication-through-the-4p-personality-styles",
    "startDate": "2026-12-22",
    "endDate": "2027-01-12",
    "time": "23:00 - 23:30 UTC",
    "startTime": "23:00",
    "endTime": "23:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-22",
      "2026-12-29",
      "2027-01-05",
      "2027-01-12"
    ],
    "tpSessionIds": [
      13304,
      13305,
      24159,
      24160
    ]
  },
  {
    "id": "lel-20261223-126",
    "courseSlug": "adapting-your-leadership-style",
    "startDate": "2026-12-23",
    "endDate": "2027-01-06",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-23",
      "2026-12-30",
      "2027-01-06"
    ],
    "tpSessionIds": [
      12119,
      12120,
      12121
    ]
  },
  {
    "id": "lel-20261223-127",
    "courseSlug": "manage-your-time-master-your-life",
    "startDate": "2026-12-23",
    "endDate": "2027-01-13",
    "time": "20:00 - 20:30 UTC",
    "startTime": "20:00",
    "endTime": "20:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-23",
      "2026-12-30",
      "2027-01-06",
      "2027-01-13"
    ],
    "tpSessionIds": [
      13384,
      13385,
      13386,
      13387
    ]
  },
  {
    "id": "lel-20261223-128",
    "courseSlug": "servant-leadership-ii-manager-as-servant-leader",
    "startDate": "2026-12-23",
    "endDate": "2027-01-13",
    "time": "22:00 - 22:30 UTC",
    "startTime": "22:00",
    "endTime": "22:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-23",
      "2026-12-30",
      "2027-01-06",
      "2027-01-13"
    ],
    "tpSessionIds": [
      14781,
      14782,
      14783,
      14784
    ]
  },
  {
    "id": "lel-20261224-129",
    "courseSlug": "4p-series-communication-from-the-passion-perspective",
    "startDate": "2026-12-24",
    "endDate": "2026-12-31",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-24",
      "2026-12-31"
    ],
    "tpSessionIds": [
      11969,
      11970
    ]
  },
  {
    "id": "lel-20261228-130",
    "courseSlug": "leading-with-an-inclusive-mindset",
    "startDate": "2026-12-28",
    "endDate": "2027-01-18",
    "time": "13:00 - 13:30 UTC",
    "startTime": "13:00",
    "endTime": "13:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-28",
      "2027-01-04",
      "2027-01-11",
      "2027-01-18"
    ],
    "tpSessionIds": [
      13366,
      24164,
      24165,
      24166
    ]
  },
  {
    "id": "lel-20261229-131",
    "courseSlug": "managing-stress",
    "startDate": "2026-12-29",
    "endDate": "2027-01-12",
    "time": "02:00 - 02:30 UTC",
    "startTime": "02:00",
    "endTime": "02:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-29",
      "2027-01-05",
      "2027-01-12"
    ],
    "tpSessionIds": [
      13405,
      24172,
      24173
    ]
  },
  {
    "id": "lel-20261229-132",
    "courseSlug": "motivation-models-carrot-or-stick",
    "startDate": "2026-12-29",
    "endDate": "2027-01-12",
    "time": "03:00 - 03:30 UTC",
    "startTime": "03:00",
    "endTime": "03:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-29",
      "2027-01-05",
      "2027-01-12"
    ],
    "tpSessionIds": [
      13602,
      24174,
      24175
    ]
  },
  {
    "id": "lel-20261229-133",
    "courseSlug": "analytical-thinking-skills",
    "startDate": "2026-12-29",
    "endDate": "2027-01-12",
    "time": "16:00 - 16:30 UTC",
    "startTime": "16:00",
    "endTime": "16:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-29",
      "2027-01-05",
      "2027-01-12"
    ],
    "tpSessionIds": [
      24183,
      24184,
      24185
    ]
  },
  {
    "id": "lel-20261230-134",
    "courseSlug": "performance-management",
    "startDate": "2026-12-30",
    "endDate": "2027-01-13",
    "time": "15:00 - 15:30 UTC",
    "startTime": "15:00",
    "endTime": "15:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-30",
      "2027-01-06",
      "2027-01-13"
    ],
    "tpSessionIds": [
      14750,
      14751,
      14752
    ]
  },
  {
    "id": "lel-20261230-135",
    "courseSlug": "new-leader-boot-camp",
    "startDate": "2026-12-30",
    "endDate": "2027-01-20",
    "time": "21:00 - 21:30 UTC",
    "startTime": "21:00",
    "endTime": "21:30",
    "format": "Virtual",
    "meetingDates": [
      "2026-12-30",
      "2027-01-06",
      "2027-01-13",
      "2027-01-20"
    ],
    "tpSessionIds": [
      13623,
      13624,
      13625,
      13626
    ]
  }
];
